import React, { FC, useState } from 'react';
import { IpoIconWrap } from './style';

interface IIPOIconProps {
  width?: number;
  height?: number;
  src: string;
  isHover?: boolean;
}

export const IPOIcon: FC<IIPOIconProps> = ({ src, width = 24, height = 24, isHover = true }) => {

  const [isError, setIsError] = useState<boolean>(true)

  return (
    <>
      { isError && <IpoIconWrap width={width} height={height} isHover={isHover}>
                     <img src={src} onError={() => setIsError(false)}/>
                   </IpoIconWrap>
     }
    </>
  );
};